export default "__VITE_ASSET__5e17b4c8__"